import { useLiveStreamAppContext } from "../ContextStore/Store";
import DataChanneling from "./DataChanneling";

const DropDownAction = () => {
  const { setAttendees, pinnedParticipants, setPinnedParticipants } =
    useLiveStreamAppContext();
  const { sendActionToAttendee } = DataChanneling();

  //Function for Sending Host Actions to Individual attendees from the drop down
  const handleAction = async (action, participantId) => {
    setAttendees((prevAttendees) =>
      prevAttendees.map((attendee) => {
        if (attendee.communicationUserId === participantId) {
          switch (action) {
            case "Pin":
              setPinnedParticipants([
                ...pinnedParticipants,
                attendee.communicationUserId,
              ]);
              return { ...attendee, isPinned: true };
            case "Unpin":
              setPinnedParticipants(
                pinnedParticipants.filter(
                  (u) => u !== attendee.communicationUserId
                )
              );
              return { ...attendee, isPinned: false };
            case "Mute":
              sendActionToAttendee(participantId, "DISABLE_MIC_FOR_INDIVIDUAL");
              return { ...attendee, isMute: true };
            case "Unmute":
              sendActionToAttendee(participantId, "ENABLE_MIC_FOR_INDIVIDUAL");
              return { ...attendee, isMute: false };
            case "DisableVideo":
              sendActionToAttendee(
                participantId,
                "DISABLE_VIDEO_FOR_INDIVIDUAL"
              );
              return { ...attendee, isVideoDisabled: true };
            case "EnableVideo":
              sendActionToAttendee(
                participantId,
                "ENABLE_VIDEO_FOR_INDIVIDUAL"
              );
              return { ...attendee, isVideoDisabled: false };
            case "DisableChat":
              sendActionToAttendee(
                participantId,
                "DISABLE_CHAT_FOR_INDIVIDUAL"
              );
              return { ...attendee, isChatDisabled: true };
            case "EnableChat":
              sendActionToAttendee(participantId, "ENABLE_CHAT_FOR_INDIVIDUAL");
              return { ...attendee, isChatDisabled: false };
            case "DisableScreenShare":
              sendActionToAttendee(
                participantId,
                "DISABLE_SCREEN_SHARE_FOR_INDIVIDUAL"
              );
              return { ...attendee, isScreenShareDisabled: true };
            case "EnableScreenShare":
              sendActionToAttendee(
                participantId,
                "ENABLE_SCREEN_SHARE_FOR_INDIVIDUAL"
              );
              return { ...attendee, isScreenShareDisabled: false };
            default:
              return attendee;
          }
        }
        return attendee;
      })
    );
  };

  return { handleAction };
};

export default DropDownAction;
